import React from "react"
import { Card, Result, List, Tag, Button, Typography } from "@mimber/ui-web"
import type { WizardSummaryStepProps } from "./WizardSummaryStep.types"

const { Title } = Typography

export const WizardSummaryStep: React.FunctionComponent<
  WizardSummaryStepProps
> = ({ stepConfig, stepStatuses, onGoToDashboard }) => {
  return (
    <Card>
      <Result
        status="success"
        title="Organization setup complete"
        subTitle="Here's a summary of what you completed during setup. Skipped steps can always be finished later from your organization's settings."
      />
      <Title level={5}>Setup Summary</Title>
      <List
        dataSource={stepConfig}
        renderItem={(step) => (
          <List.Item
            extra={
              <Tag
                color={
                  stepStatuses[step.key] === "completed" ? "green" : "default"
                }
              >
                {stepStatuses[step.key] === "completed"
                  ? "Completed"
                  : "Skipped"}
              </Tag>
            }
          >
            <List.Item.Meta title={step.title} description={step.description} />
          </List.Item>
        )}
      />
      <Button
        type="primary"
        onClick={onGoToDashboard}
        style={{ marginTop: 16 }}
      >
        Go to Dashboard
      </Button>
    </Card>
  )
}
